import { toast } from "react-toastify";
import userService from "../../services/user.service";
import { GENERATE_REPORT_FAIL, GENERATE_REPORT_PENDING, GENERATE_REPORT_SUCCESS } from "../types";

export const generateReport = (body) => async (dispatch) => {
    dispatch({
        type: GENERATE_REPORT_PENDING,
        payload: { report: "isLoading" },
    });
    return userService.generateReport(body)
        .then(() => {
            dispatch({
                type: GENERATE_REPORT_SUCCESS,
                payload: { report: true },
            });
            return Promise.resolve();
        })
        .catch((error) => {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                "Failed to generate report";
            toast.error(message, { autoClose: 2000 });
            dispatch({
                type: GENERATE_REPORT_FAIL,
            });
            return Promise.reject();
        });
};